export const SET_NAVBAR_TEXT = "NAVBAR/SET_TEXT";
export const SET_GO_BACK = "NAVBAR/SET_CLOSE";
export const CLEAR_NAVBAR = "NAVBAR/CLEAR";
export const SET_EXIT = "NAVBAR/SET_EXIT";
export const SET_CLOSE = "NAVBAR/SET_CLOSE";
